import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-circular-progressbar/dist/styles.css";

import ExamPage from "../../components/SPanel/Exam";

function SPExam() {
   return (
      <main className="main">
         <section className="page-wrapper">
            <ExamPage />
         </section>
      </main>
   );
}

export default SPExam;
